export const SourceCommandeLabels = {
    BOITE_MAIL: "Boîte mail",
    MAIL_SECURISE: "Mail sécurisé",
    AUTRE: "Autres",
    PORTAIL_COLLECTIVITE: "Portail collectivité"
};

export const SourceCommandeValues = Object.fromEntries(
    Object.entries(SourceCommandeLabels).map(([key, label]) => [key, key])
);
